import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { IdentityRole } from 'src/app/shared/models/identityRole';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { CuotaPlanta } from 'src/app/shared/models/cuotaPlanta';
import { UbicacionAlmacenamiento } from 'src/app/shared/models/ubicacionAlmacenamiento';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Deposito } from 'src/app/shared/models/deposito';
import { Producto } from 'src/app/shared/models/producto';



@Component({
  selector: 'app-cuotas-plantas-dialog',
  templateUrl: './cuotas-plantas-dialog.component.html'
})
export class CuotasPlantasDialogComponent {
  c: CuotaPlanta;
  cargos: IdentityRole[] = [];
  codigoEdit: number = -1;
  companias: Compania[] = [];
  form: FormGroup;
  idTipo: number;
  mensaje: number = 0;
  salesOrgs: SalesOrg[] = [];
  salesOrgSeleccionada: SalesOrg;
  companiaSeleccionada: Compania;
  plantas: Deposito[]= [];
  ubicacionesAlmacenamientos: UbicacionAlmacenamiento[]= [];
  plantaSeleccionada: Deposito;
  slSeleccionado: UbicacionAlmacenamiento;

  productoSeleccionado: Producto;
  productosEncontrados: any;
  minLengthTermProducto = 1;
  fcAutocompleteProducto = new FormControl('');
  hintProducto: string = ""
  loadingFcAutocompleteProducto = false;
  meses: String[] = [];
  anios: String[] = [];

  today: Date;
  sixMonthsAgo: Date;
  years: Date;

  constructor(private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CuotasPlantasDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private parametrosService: ParametrosService,
    private snackBarService: SnackbarService,
    private usuariosService: UsuariosService,
    private tablasService: TablasService,
    private productosService: ProductosService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      autor: [''],
      fechaCreacion: [new Date()],
      habilitacion: [true],
      idCompania: ['', Validators.required],
      idPais: [''],
      idSalesOrg: ['', Validators.required],

      idProducto: ['', Validators.required],
      producto: ['', Validators.required],
      idPlanta: ['', Validators.required],
      idUbicacionAlmacenamiento: [''],
      cuotaCant: [0,[ Validators.required, Validators.min(0.001)]],
      // mesyAnio: ['', Validators.required],
      mes: ['', Validators.required],
      anio: ['', Validators.required],
      codigo: [0]
    })
    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.c != null) {
      this.codigoEdit = data.c.codigo
      this.c = data.c

    }
  }

  public Etiquetas: {

    IdCompania: string,
    IdSalesOrg: string,
    IdProducto: string,
    Producto: string,
    Mes: string,
    Anio: string,
    IdPlanta: string,

    IdUbicacionAlmacenamiento: string,
    CuotaCant: string

  }

  public Validaciones: {

    IdProducto: string,
    IdPlanta: string
    IdUbicacionAlmacenamiento: string
    CuotaCant: string
    Mes: string,
    Anio: string,
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {

      IdCompania: this.configService.etiquetas.Compania,
      IdSalesOrg: this.configService.etiquetas.SalesOrg,
      IdProducto: this.configService.etiquetas.IdProducto,
      Producto: this.configService.etiquetas.Producto,
      Mes: this.configService.etiquetas.Mes,
      Anio: this.configService.etiquetas.Anio,
      IdPlanta: this.configService.etiquetas.IdPlanta,

      IdUbicacionAlmacenamiento: this.configService.etiquetas.StorageLocation,
      CuotaCant: this.configService.etiquetas.CuotaCant,

    }

    this.Validaciones = {
     
      IdProducto: this.configService.validaciones.Producto,
      IdPlanta: this.configService.validaciones.IdPlanta,
      IdUbicacionAlmacenamiento: this.configService.validaciones.IdUbicacionAlmacenamiento,
      CuotaCant: this.configService.validaciones.CuotaCant,
      Mes: this.configService.validaciones.Mes,
      Anio: this.configService.validaciones.Anio,

    }
    this.fcAutocompleteProducto.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermProducto
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.productosEncontrados = [];
          this.loadingFcAutocompleteProducto = true;
        }),
        switchMap(value => this.productosService.cProductosAutocompleteSearch(this.loggedService.logged.idPais, this.form.controls['idCompania'].value,
          this.form.controls['idSalesOrg'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteProducto = false
            }),
          )
        )
      )
      .subscribe((data: Producto[]) => {
        //this.scrollToInvalidFormControls(this.form);
        if (data != null) {
          this.productosEncontrados = data;

        }

      });
    forkJoin([

      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.tablasService.cPlantas(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg),
      this.productosService.cStoragesLocationsPlanta(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.form.controls['idPlanta'].value),
      this.productosService.cCuotaPlantaDB(this.codigoEdit)

    ]).subscribe((data: [Compania[], SalesOrg[], Deposito[], UbicacionAlmacenamiento[], CuotaPlanta]) => {

      if (data[0].length) {
        this.companias = data[0];
      }

      if (data[1].length) {
        this.salesOrgs = data[1];
      }

      if (data[2].length) {
        this.plantas = data[2];
      }
      if (data[3].length) {
        this.ubicacionesAlmacenamientos = data[3];
      }


      if (this.idTipo == 1) {
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);
        if (this.companias.length) {
          this.form.controls['idCompania'].setValue(this.companias[0].id);
        }
        if (this.salesOrgs.length) {
          this.form.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
        }



      }

      if (typeof this.c != 'undefined') {
        if (this.codigoEdit != -1) {

          if (data[4] != null) {

this.seleccionarPlanta(data[4].idPlanta);

            this.form.controls['idCompania'].setValue(data[4].idCompania);
            this.form.controls['idPais'].setValue(data[4].idPais);
            this.form.controls['idSalesOrg'].setValue(data[4].idSalesOrg);
            this.form.controls['habilitacion'].setValue(data[4].habilitacion);
            this.form.controls['codigo'].setValue(data[4].codigo);
            this.form.controls['autor'].setValue(data[4].autor);
            this.form.controls['idProducto'].setValue(data[4].idProducto);
            this.form.controls['idPlanta'].setValue(data[4].idPlanta);
            this.form.controls['idUbicacionAlmacenamiento'].setValue(data[4].idUbicacionAlmacenamiento);
            this.form.controls['mes'].setValue(data[4].mes);
            this.form.controls['anio'].setValue(data[4].anio);
            this.form.controls['producto'].setValue(data[4].producto);
            this.form.controls['cuotaCant'].setValue(data[4].cuotaCant);
            this.productoSeleccionado = new Producto;
this.productoSeleccionado.id = data[4].idProducto;
this.productoSeleccionado.descripcion = data[4].producto;

            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }
      this.seleccionarCompania(this.form.controls['idCompania'].value);
      this.seleccionarSalesOrg(this.form.controls['idSalesOrg'].value);


    });
    this.today = new Date();
    let i: number = 0;
    let x: number = this.today.getFullYear() - 2;

    for (i = 0; i <= 5; i++) {
      this.anios[i] = x.toString();
      x++;
    }
    this.meses = ['01','02','03','04','05','06','07','08','09','10','11','12']
    // this.years = new Date(this.today.getFullYear() + 5, this.today.getMonth(), this.today.getDate());

    // this.sixMonthsAgo = new Date();
    // this.sixMonthsAgo.setMonth(this.today.getMonth() - 6);
  }
  scrollToInvalidFormControls(form: any) {
    throw new Error('Method not implemented.');
  }
  compareCompanias(cLista: any, cA: any): boolean {
    if (typeof cLista != 'undefined' && typeof cA != 'undefined') {

      return cLista === cA;
    }
  }

  compareSalesOrgs(salesOrgLista: any, salesOrg: any): boolean {
    if (typeof salesOrgLista != 'undefined' && typeof salesOrg != 'undefined') {

      return salesOrgLista === salesOrg;
    }
  }
  comparePlantas(pLista: any, p: any): boolean {
    if (typeof pLista != 'undefined' && typeof p != 'undefined') {

      return pLista === p;
    }
  }
  compareStoragesLocations(slLista: any, sl: any): boolean {
    if (typeof slLista != 'undefined' && typeof sl != 'undefined') {
      return slLista === sl;
    }
  }
  compareMeses(mLista: any, m: any): boolean {
    if (typeof mLista != 'undefined' && typeof m != 'undefined') {

      return mLista === m;
    }
  }
  compareAnios(aLista: any, a: any): boolean {
    if (typeof aLista != 'undefined' && typeof a != 'undefined') {

      return aLista === a;
    }
  }
  openDatePicker(dp) {

    dp.open();
  }

  closeDatePicker(eventData: any, dp?: any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    console.log(this.years)
    console.log(eventData)

    this.form.controls['mesyAnio'].setValue(eventData);
    dp.close();
  }
  guardar() {

    switch (this.idTipo) {
      case 1:

        this.productosService.aCuotaPlanta(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:

        this.productosService.mCuotaPlanta(this.form.value).subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }
  seleccionarCompania(c: any) {

    this.companiaSeleccionada = null;

    if (c != null) {
      this.companiaSeleccionada = this.companias.find(c => c.id == this.form.controls['idCompania'].value);
    }
  }

  seleccionarSalesOrg(s: any) {

    this.salesOrgSeleccionada = null;

    if (s != null) {
      this.salesOrgSeleccionada = this.salesOrgs.find(c => c.id == this.form.controls['idSalesOrg'].value);
    }
  }


  seleccionarPlanta(p: any) {

    this.ubicacionesAlmacenamientos = []
    this.plantaSeleccionada = null;
    if (p != null) {
      this.plantaSeleccionada = this.plantas.find(c => c.idPlanta == p);
      if (this.plantaSeleccionada != null) {

        this.productosService
          .cStoragesLocationsPlanta(this.plantaSeleccionada.idPais, this.plantaSeleccionada.idCompania, this.plantaSeleccionada.idSalesOrg, this.plantaSeleccionada.idPlanta)
          .subscribe((data: UbicacionAlmacenamiento[]) => {

            if (data != null) {
              this.ubicacionesAlmacenamientos = data;

            }

          })

      }
    }
    else {
      this.form.controls['planta'].reset();
      this.form.controls['idPlanta'].reset();

    }

  }
  seleccionarStorageLocation(sl: any) {

    this.slSeleccionado = null;
    if (sl != null) {
      this.slSeleccionado = this.ubicacionesAlmacenamientos.find(c => c.id == this.form.controls['idUbicacionAlmacenamiento'].value);
    }

  }

  seleccionarProducto(i: any) {

    if (i != "-1") {
      this.productoSeleccionado = i;

      this.form.controls['idProducto'].setValue(this.productoSeleccionado.id);
      this.form.controls['producto'].setValue(this.productoSeleccionado.descripcion);

    }
    else {
      this.form.controls['idProducto'].reset();
      this.form.controls['producto'].reset();

      this.productoSeleccionado = null;
    }
  }



  getOptionTextProducto(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputProducto(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermProducto) {
      this.productosEncontrados = [];
      this.productoSeleccionado = null;
    }
  }

  limpiarProducto(resetFormControl: boolean) {
    this.productosEncontrados = [];
    this.seleccionarProducto("-1");
    if (resetFormControl) {
      this.fcAutocompleteProducto.setValue('');
    }
    this.form.markAsUntouched();
    this.form.markAsPristine();

  }
  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
